import(/* webpackMode: "eager" */ "/vercel/path0/app/(public)/rotations/page.tsx");
